import { useContext } from 'react';

import { useQuery } from '@apollo/client';

import { Store } from '@website/Store';
import { UseCheckHostPermissionsDocument } from '@website/types/graphqlOperations';

/**
 * Check if a user has host admin permissions
 * @param urlSlug Host URL slug
 */
export default function useCheckHostPermissions(
  urlSlug: string,
): UseCheckHostPermissionsRes {
  const { state } = useContext(Store);

  const isAdmin = state.user.roles.includes('admin');

  // Get the user host roles
  const { data } = useQuery(UseCheckHostPermissionsDocument, {
    variables: { id: state.user.id },
    skip: !state.user.id, // Only run once we have the userID
    fetchPolicy: 'cache-and-network',
  });

  // Get the user host roles
  const isHostAdmin: boolean = data
    ? data.user.hostRoles.items.some((i) => i.host.urlSlug === urlSlug)
    : false;

  return {
    isAdmin: state.user.roles.includes('admin'),
    isHostAdmin,
    isAuthorized: isAdmin || isHostAdmin,
  };
}

export interface UseCheckHostPermissionsRes {
  /** True if the user is a global (Skyhook) admin */
  isAdmin: boolean;
  /** True if the user is a host admin */
  isHostAdmin: boolean;
  /** True if the user is a host admin or global admin */
  isAuthorized: boolean;
}
